import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import MainLayout from 'src/layouts/main';
import CompactLayout from 'src/layouts/compact';
import {
  ComingSoon,
  Maintenance,
  Page500,
  Page404,
  Page403,
  HomePage,
} from '../elements';

export const compactRoute: RouteObject = {
  path: '*',
  element: <CompactLayout />,
  children: [
    { path: 'coming-soon', element: <ComingSoon /> },
    { path: 'maintenance', element: <Maintenance /> },
    { path: '500', element: <Page500 /> },
    { path: '404', element: <Page404 /> },
    { path: '403', element: <Page403 /> },
    { path: '*', element: <Navigate to="/404" replace /> },
  ],
};

export const homeRoute: RouteObject = {
  path: '/',
  element: <MainLayout />,
  children: [{ element: <HomePage />, index: true }],
};

export const fallbackNotFoundRoute: RouteObject = {
  path: '*',
  element: <Navigate to="/404" replace />,
};
